import(/* webpackMode: "eager" */ "/harness/packages/micro-apps/src/app/globals.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/harness/packages/micro-apps/src/components/WebVitals/WebVitals.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RootProviders"] */ "/harness/packages/micro-apps/src/providers/RootProviders.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrustedTypes"] */ "/harness/packages/pixel-party/src/google/trusted-types.ts");
